<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Licenc</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <div class="lic">
    <ion-progress-bar type="indeterminate" *ngIf="betolt"></ion-progress-bar>

    <ng-container *ngIf="!betolt">
      <!-- Teljes állapot -->
      <div class="lic-sav" [ngClass]="allapotKod" role="status">
        <ion-icon [name]="savIkon"></ion-icon>
        <div>
          <div class="lic-sav-cim">{{ savCim }}</div>
          <div class="lic-sav-szoveg">{{ savSzoveg }}</div>
        </div>
      </div>

      <!-- Előfizetés | Telepített alkalmazás -->
      <section class="lic-panel">
        <div class="lic-oszlop">
          <div class="lic-fej">
            <div class="lic-ikon"><ion-icon name="ribbon-outline"></ion-icon></div>
            <div>
              <div class="lic-cimke">Előfizetés</div>
              <div class="lic-nev">{{ elofizeto }}</div>
            </div>
          </div>

          <dl class="lic-adatok">
            <div><dt>Előfizetés:</dt><dd>{{ elofizetesAllapot }}</dd></div>
            <div><dt>Érvényesség lejárata:</dt><dd>{{ lejarat }}</dd></div>
            <div *ngIf="licenc?.id"><dt>Nyilvános azonosító:</dt><dd class="mono">{{ licenc.id }}</dd></div>
            <div *ngIf="csomag"><dt>{{ regiAkt ? 'Csomag:' : 'Telepítés:' }}</dt><dd>{{ csomag }}</dd></div>
            <div *ngIf="licenc"><dt>Korlátok:</dt><dd>{{ korlat('max_ceg') }} cég · {{ korlat('max_felhasznalo') }} felhasználó</dd></div>
          </dl>

          <div class="lic-modulok" *ngIf="licenc">
            <span class="lic-cimke">Licencelt modulok</span>
            <div class="lic-chipek">
              <span class="lic-chip" *ngFor="let m of modulok">{{ m }}</span>
              <span class="lic-chip ures" *ngIf="!modulok.length">mind (nincs korlátozva)</span>
            </div>
          </div>

          <div class="lic-linkek">
            <a [href]="fiokUrl" target="_blank" rel="noopener">Előfizetés módosítása <ion-icon name="open-outline"></ion-icon></a>
            <a routerLink="/admin/licenc">Licenckulcs megadása</a>
          </div>
        </div>

        <div class="lic-oszlop">
          <div class="lic-fej">
            <div class="lic-ikon jel" aria-hidden="true">
              <svg viewBox="0 0 40 40"><rect x="2" y="2" width="17" height="17" rx="4" fill="#f7941d"/><rect x="21" y="2" width="17" height="17" rx="4" fill="#0a6fd1"/><rect x="2" y="21" width="17" height="17" rx="4" fill="currentColor"/><rect x="21" y="21" width="17" height="17" rx="4" fill="#2e9e5b"/></svg>
            </div>
            <div>
              <div class="lic-cimke">Telepített alkalmazás</div>
              <div class="lic-nev">{{ termek }}</div>
            </div>
          </div>

          <dl class="lic-adatok">
            <div><dt>Alkalmazás verziója:</dt><dd class="mono">{{ verzio }}</dd></div>
            <div *ngIf="ujVerzio"><dt>Elérhető verzió:</dt><dd class="mono">{{ ujVerzio }}</dd></div>
            <div *ngIf="allapot?.aktiv"><dt>Utolsó licencellenőrzés:</dt><dd>{{ utolsoKapcsolat }}</dd></div>
          </dl>

          <div class="lic-linkek">
            <a routerLink="/changelog">Újdonságok</a>
            <a href="javascript:void(0)" (click)="nevjegy = !nevjegy">A Cronomit névjegye</a>
            <a routerLink="/hibajegy">Alkalmazás hibaelhárítása</a>
          </div>

          <div class="lic-nevjegy" *ngIf="nevjegy">
            <b>{{ termek }}</b> {{ verzio }}<br>
            Integrált intézményi és vállalati ügyviteli rendszer.<br>
            © {{ ev }} Cronomit. Minden jog fenntartva.
          </div>
        </div>
      </section>

      <p class="lic-lab" *ngIf="allapot?.aktiv && allapot?.turelmi_nap_osszesen">
        Kapcsolat nélkül a program {{ allapot.turelmi_nap_osszesen }} napig működik tovább<span *ngIf="allapot?.turelmi_nap_hatra != null">
        (még {{ allapot.turelmi_nap_hatra }} nap)</span>.
      </p>
    </ng-container>
  </div>
</ion-content>
